import { FC, Fragment } from 'react';
// 
import QuizPreview from './QuizPreview';
import SectionMain from './SectionMain';
import SectionPrizes from './SectionPrizes';
import SectionBuckets from './SectionBuckets';
import SectionTheme from './Theme';
import SectionImages from './SectionImages';
import QuestionsSettings from './QuestionsSettings';

const TabContentQuiz:FC = () => {
  return (
    <Fragment>
      <div className="w-full overflow-y-hidden tablet:overflow-y-auto overflow-x-hidden" react-action="scroll">
        <SectionMain />
        <SectionPrizes />
        <SectionBuckets />
        <SectionTheme />
        <SectionImages />
        <QuestionsSettings />
      </div>
      <QuizPreview preview="quiz" />
    </Fragment>
  )
}

export default TabContentQuiz;
